import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, Edit3, Trophy, Lock } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const MOBILE_IMG = '/images/participacion-usuario.png';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6, ease: 'easeOut', delay },
});

export default function MobileApp() {
  const { t } = useLanguage();
  const m = t.mobileApp;

  return (
    <section className="py-14 md:py-20 bg-[#1A222B]" data-testid="mobile-app-section">
      <div className="section-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: content */}
          <motion.div {...fadeUp()}>
            <div className="divider-gold" />
            <h2 className="heading-lg mb-5">{m.title}</h2>
            <p className="text-[#8A9099] text-base leading-relaxed mb-8">{m.body}</p>

            {/* Features grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
              {m.features.map((feat, i) => (
                <div key={i} className="flex items-center gap-2.5">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#D5A63B] flex-shrink-0" />
                  <span className="text-[#F3F1EB] text-sm">{feat}</span>
                </div>
              ))}
            </div>

            {/* Note box */}
            <div className="bg-[#0F6B49]/10 border border-[#0F6B49]/30 rounded-xl p-4 flex gap-3">
              <Lock size={18} className="text-[#D5A63B] flex-shrink-0 mt-0.5" />
              <p className="text-[#8A9099] text-sm leading-relaxed">{m.note}</p>
            </div>
          </motion.div>

          {/* Right: phone mockup */}
          <motion.div className="flex justify-center lg:justify-end" {...fadeUp(0.2)}>
            <div className="relative">
              {/* Glow */}
              <div className="absolute inset-0 bg-[#D5A63B]/10 rounded-3xl blur-2xl scale-110" />
              <div className="relative rounded-3xl overflow-hidden border-2 border-[#D5A63B]/30 shadow-2xl
                max-w-xs lg:max-w-sm w-full" data-testid="mobile-mockup">
                <img src={MOBILE_IMG} alt="App móvil de predicción"
                  className="w-full object-cover" />
              </div>
              {/* Badge */}
              <div className="absolute -bottom-4 -left-4 bg-[#0F6B49] rounded-xl px-4 py-2.5 border border-[#D5A63B]/30 shadow-lg">
                <div className="flex items-center gap-2">
                  <Smartphone size={14} className="text-[#D5A63B]" />
                  <span className="text-white text-xs font-bold">Sin App</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
